<style scoped>
.dialog-id-row {
  overflow-y: auto;
  display: block;
  height: 500px;
}
</style>

<template>
  <v-modal
    v-if="show"
    :show="show"
    @update:show="$emit('update:show', $event)"
    :isTableModal="true"
  >
    <h4 slot="header" class="title title-up">
      Empfänger ({{ typeHeader }}) zur Rundmail (ID: {{ id }})
    </h4>
    <div v-if="customers === null" class="d-flex justify-content-around">
      <i class="fas fa-spinner fa-spin fa-10x"></i>
    </div>
    <div class="dialog-id-row" v-else>
      <span v-for="(customer, key) in customers" :key="key">
        <customer-cell :content="customer"></customer-cell>
        <a :href="`/dialogkontrolle/${customer.id}-${senderId}`"
          >{{ customer.id }} - {{ senderId }}</a
        >
      </span>
    </div>
  </v-modal>
</template>

<script lang="babel">
import CustomerCell from "@/components/table/CustomerCell";
import { Modal } from "src/components/UIComponents";

export default {
  components: {
    CustomerCell,
    'v-modal': Modal
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    senderId: {
      type: Number,
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: "read"
    }
  },
  data() {
    return {
      customers: null
    };
  },
  methods: {
    getCustomer() {
      return this.$http.get(`/api/v1/circularMail/customers/${this.id}/?type=${this.type}`, {
        params: { type: this.type }
      })
      .then(({ data }) => {
        this.customers = data;
      });
    }
  },
  computed: {
    typeHeader() {
      if (this.type == "read") {
        return "gelesen";
      }
      return "geantwortet";
    }
  },
  watch: {
    show(newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.getCustomer();
      }
    }
  }
};
</script>
